import { Checkbox, ErrorMessage } from "@nju/form";
import { Panel, Separator, Text } from "@nju/ui";
import { formatPhoneNumber, POSITIVE_DIGITS } from "@nju/utils";
import { Row } from "./Row";
import { Title } from "./Title";

interface IUserInfoProps {
  contactNumber?: string;
  errorMessage: string | undefined;
  firstName: string;
  lastName: string;
  isDisagreementSelected: boolean;
  toggleAgreement: () => void;
}

export function UserInfo({
  firstName,
  errorMessage,
  lastName,
  contactNumber,
  isDisagreementSelected,
  toggleAgreement,
}: IUserInfoProps) {
  return (
    <Panel testId="user-personal-information">
      <div className="self-start">
        <Title iconName="address-card" title="wszystko o mnie" />
        <Separator size="s" />
        <Row title="imię" value={firstName} />
        <Separator size="xs" tone="invisible" />
        <Row title="nazwisko" value={lastName} />
        <Separator size="m" />
        {contactNumber && (
          <>
            <Row
              title="numer telefonu"
              value={formatPhoneNumber(contactNumber, POSITIVE_DIGITS, " ")}
            />
            <Separator size="xs" tone="invisible" />
          </>
        )}
        <Checkbox
          checkboxPosition="top"
          isSelected={isDisagreementSelected}
          name="agreement"
          onChange={toggleAgreement}
        >
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            nie będziesz otrzymywać od nas informacji ani przypomnień, nie
            będziemy też kontaktować się z Tobą telefonicznie w sprawie
            ewentualnych problemów technicznych
          </Text>
        </Checkbox>
        {errorMessage && (
          <>
            <Separator size="xxs" tone="invisible" />
            <ErrorMessage message={errorMessage} />
          </>
        )}
      </div>
    </Panel>
  );
}
